/**
 * Iniciales para un avatar: la primera letra de las dos primeras palabras
 * («Andrés Pons» → «AP») o las dos primeras letras si solo hay una palabra
 * («ACME» → «AC»). Devuelve `--` si no hay texto.
 */
export function buildInitials(value: string): string {
  const source = value.trim();
  if (!source) return '--';
  const words = source
    .replace(/\s+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2);
  if (words.length === 0) return '--';
  const first = words[0] ?? '';
  if (words.length === 1) {
    return first.slice(0, 2).toUpperCase();
  }
  const second = words[1] ?? '';
  return `${first[0] ?? ''}${second[0] ?? ''}`.toUpperCase();
}
